import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '../assets/icons/magnifying-glass.svg';

const Search = ({styles}) => {
  const navigate = useNavigate();

  const searchInputValue = useRef(null);

  const onSearch = (e) => {
    e.preventDefault();
    searchInputValue.current && navigate(`Search/${searchInputValue.current}`);
  };

  return (
    <form
      className={`sm:w-98 h-8 rounded-2xl flex flex-row-reverse ${styles}`}
      onSubmit={onSearch}
    >
      <div className="cursor-pointer p-2" onClick={onSearch}>
        <SearchIcon className="w-full h-full" style={{maxWidth: '2rem'}} />
      </div>
      <input
        className="rounded-l-3xl w-full focus:outline-0"
        style={{ direction: 'rtl' }}
        onChange={(e) => (searchInputValue.current = e.target.value)}
      />
    </form>
  );
};

export default Search;
